
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa63a4be0f9d938191327f789323876a6en from './en.yaml'
            i18n.addResourceBundle('en', 'a63a4be0f9d938191327f789323876a6', flattenObject(nsa63a4be0f9d938191327f789323876a6en), true, true);
        
        export default 'a63a4be0f9d938191327f789323876a6';
    